import { isOrganization } from './cookies';
export const sendGTM = (data) => {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push(data);
};
export const formEventGTM = (options) => {
    return Object.assign({ event: options.event || 'submitForm' }, options);
};
export const handleGTMSuccess = (options) => {
    sendGTM(formEventGTM(Object.assign(Object.assign({}, options), { type: 'SUCCESS' })));
    sendGTM(Object.assign(Object.assign({}, options), { type: 'SUCCESS', event: 'AutentiAction' }));
};
export const handleGTMError = (options) => {
    sendGTM(formEventGTM(Object.assign(Object.assign({}, options), { type: 'ERROR' })));
    sendGTM(Object.assign(Object.assign({}, options), { type: 'ERROR', event: 'AutentiAction' }));
};
export const handleGTMErrorValidate = (options) => {
    sendGTM(formEventGTM(Object.assign(Object.assign({}, options), { type: 'ERROR_VALIDATE' })));
    sendGTM(Object.assign(Object.assign({}, options), { type: 'ERROR_VALIDATE', event: 'AutentiAction' }));
};
export const handleGTMErrorMsg = (options) => {
    sendGTM(formEventGTM(Object.assign(Object.assign({}, options), { type: 'ERROR_MSG' })));
    sendGTM(Object.assign(Object.assign({}, options), { type: 'ERROR_MSG', event: 'AutentiAction' }));
};
export const handleGTMMsg = (options) => {
    sendGTM(formEventGTM(Object.assign({}, options)));
    sendGTM(Object.assign(Object.assign({}, options), { event: 'AutentiAction' }));
};
export const hasFormErrors = (errors) => errors && Object.keys(errors).length > 0;
export const standardErrorData = (val) => {
    return {
        timestamp: val.timestamp,
        exceptionId: val.exceptionId,
        errorCode: val.errorCode,
        statusCode: val.statusCode,
    };
};
export const standardErrorMsgData = (val) => {
    return {
        timestamp: new Date().getTime(),
        errorMsg: val.errorMsg,
    };
};
const getGtmSemanticIdentifiers = (semanticIdentifiers) => semanticIdentifiers.reduce((all, obj) => {
    all[obj.typeName] = obj.value;
    return all;
}, {});
const getBaseUserData = (currentUser) => {
    const semanticIdentifiers = currentUser.organizationSemanticIdentifiers;
    return {
        email: currentUser.boxes[0].identifier,
        id: currentUser.boxes[0].externalId,
        isOrganization: isOrganization(),
        givenName: currentUser.givenName,
        surname: currentUser.surname,
        countryCode: currentUser.countryCode,
        role: currentUser.role,
        jobTitle: currentUser.jobTitle,
        phoneNo: currentUser.phoneNo,
        organizationName: currentUser.organizationName,
        language: currentUser.language,
        organizationSemanticIdentifiers: semanticIdentifiers && getGtmSemanticIdentifiers(semanticIdentifiers),
        organizationId: currentUser.organizationExternalId || null,
    };
};
export const getDocumentSendingStatistics = (state) => {
    const statistics = state.planSubscriptions.getIn([
        'billing',
        'activeBilling',
        'statistics',
    ]);
    return statistics.find((item) => item.operation === 'DOCUMENT_SENDING');
};
export const getBaseUser = (state) => {
    const currentUser = state.naturalUser.get('data') || state.organizationUser.get('data');
    return currentUser
        ? {
            base: Object.assign(Object.assign({}, getBaseUserData(currentUser)), { statistics: getDocumentSendingStatistics(state) }),
        }
        : { error: 'current user not found' };
};
const getUserBillingData = (billing) => ({
    planName: billing.subscription.planShortName,
    expirationDate: billing.subscription.expirationDate,
    monthlyExpirationDate: billing.activeBilling.expirationDate,
    statistics: billing.activeBilling.statistics.find((item) => item.operation === 'DOCUMENT_SENDING'),
});
export const getBaseUserWithBillingData = (state, billing) => {
    const currentUser = state.naturalUser.get('data') || state.organizationUser.get('data');
    return currentUser
        ? {
            base: Object.assign(Object.assign({}, getBaseUserData(currentUser)), getUserBillingData(billing)),
        }
        : { error: 'current user not found' };
};
export const getBaseUserFromPayload = (currentUser) => {
    return currentUser
        ? {
            base: getBaseUserData(currentUser),
        }
        : { error: 'current user not found' };
};
export const getOrganizationInvoiceInfoFromParams = (data) => {
    const { email, city, address, zipCode, organizationName, identifierValue, planId, } = data.params;
    return {
        payload: {
            email: email,
            city: city,
            address: address,
            zipCode: zipCode,
            organizationName: organizationName,
            users: data.getSubscribers,
            vatId: identifierValue,
            product: planId,
        },
    };
};
export const getNaturalInvoiceInfoFromParams = (data) => {
    const { email, city, address, zipCode, givenName, surname, planId } = data;
    return {
        payload: {
            email: email,
            givenName: givenName,
            planId: planId,
            surname: surname,
            city: city,
            address: address,
            zipCode: zipCode,
        },
    };
};
